'use strict';

/**
 * @name position
 */

exports.getCity = require('./get-city.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/position/index.js
// module id = 610
// module chunks = 0